import React from 'react';
import { connect, DispatchProp } from 'react-redux';

import { Select } from '@dndbeyond/character-components/es';
import {
    rulesEngineSelectors,
    Action,
    ActionUtils,
    characterActions,
    Constants,
    HtmlSelectOption,
    RuleData,
} from '@dndbeyond/character-rules-engine/es';

import * as sidebarActions from '../../../actions/sidebar/actions';
import { SidebarHeader, SidebarSubheading } from '../../../components/Sidebar';
import { SharedAppState } from '../../../stores/typings';
import { PaneComponentEnum, PaneIdentifierUtils } from '../../../utils';
import CustomActionsPaneSummary from './CustomActionsPaneSummary';

interface Props extends DispatchProp {
    actions: Array<Action>;
    ruleData: RuleData;
}
class CustomActionsPane extends React.PureComponent<Props> {
    handleCustomActionShow = (action: Action): void => {
        const { dispatch } = this.props;

        const mappingId = ActionUtils.getMappingId(action);
        if (mappingId !== null) {
            dispatch(
                sidebarActions.paneHistoryPush(
                    PaneComponentEnum.CUSTOM_ACTION,
                    PaneIdentifierUtils.generateCustomAction(mappingId),
                ),
            );
        }
    };

    handleCustomAttackRemove = (action: Action): void => {
        const { dispatch } = this.props;

        const mappingId = ActionUtils.getMappingId(action);
        if (mappingId !== null) {
            dispatch(sidebarActions.paneHistoryStart(PaneComponentEnum.CUSTOM_ACTIONS));
            dispatch(characterActions.customActionRemove(mappingId));
        }
    };

    handleActionAdd = (actionType: string): void => {
        const { dispatch, actions } = this.props;

        dispatch(characterActions.customActionCreate(`Custom Action ${actions.length + 1}`, actionType as any));
    };

    renderActions = (actions: Array<Action>): React.ReactNode => {
        const { ruleData } = this.props;

        if (!actions.length) {
            return null;
        }

        return (
            <div className="ct-custom-actions-pane__actions">
                {actions.map((action, idx) => (
                    <CustomActionsPaneSummary
                        key={`${action.id} + ${idx}`}
                        action={action}
                        ruleData={ruleData}
                        onDetailShow={this.handleCustomActionShow}
                        onRemove={this.handleCustomAttackRemove}
                    />
                ))}
            </div>
        );
    };

    renderActionGroup = (heading: string, actionType: Constants.ActionTypeEnum): React.ReactNode => {
        const { actions } = this.props;

        let filteredActions = actions.filter((action) => ActionUtils.getActionTypeId(action) === actionType);
        if (!filteredActions.length) {
            return null;
        }

        return (
            <div className="ct-custom-actions-pane__group">
                <div className="ct-custom-actions-pane__group-heading">
                    <SidebarSubheading>{heading}</SidebarSubheading>
                </div>
                <div className="ct-custom-actions-pane__group-actions">{this.renderActions(filteredActions)}</div>
            </div>
        );
    };

    renderAdd = (): React.ReactNode => {
        let customActionOptions: Array<HtmlSelectOption> = [
            { label: 'General', value: Constants.ActionTypeEnum.GENERAL },
            { label: 'Spell', value: Constants.ActionTypeEnum.SPELL },
            { label: 'Weapon', value: Constants.ActionTypeEnum.WEAPON },
        ];
        return (
            <div className="ct-custom-actions-pane__add">
                <SidebarSubheading>Add new Actions</SidebarSubheading>
                <Select
                    options={customActionOptions}
                    resetAfterChoice={true}
                    onChange={this.handleActionAdd}
                    value={null}
                />
            </div>
        );
    };

    render() {
        const {} = this.props;

        return (
            <div className="ct-custom-actions-pane">
                <SidebarHeader>Manage Custom Actions</SidebarHeader>
                {this.renderActionGroup('General', Constants.ActionTypeEnum.GENERAL)}
                {this.renderActionGroup('Spells', Constants.ActionTypeEnum.SPELL)}
                {this.renderActionGroup('Weapons', Constants.ActionTypeEnum.WEAPON)}
                {this.renderAdd()}
            </div>
        );
    }
}

function mapStateToProps(state: SharedAppState) {
    return {
        actions: rulesEngineSelectors.getCustomActions(state),
        ruleData: rulesEngineSelectors.getRuleData(state),
    };
}

export default connect(mapStateToProps)(CustomActionsPane);
